// Filter Actions
export const filterToggleClick = () => ({
  type: 'FILTER_TOGGLE_CLICK',
});

export const mediaButtonClick = (event, filterName) => ({
  type: 'MEDIA_BUTTON_CLICK',
  event,
  filterName,
});

export const buttonClick = (event, filterName) => ({
  type: 'FILTER_BUTTON_CLICK',
  event,
  filterName,
});

export const closeAllDropdowns = () => ({
  type: 'CLOSE_ALL_DROPDOWNS',
});

export const filterClick = option => ({
  type: 'SELECT_FILTER',
  option,
});

export const removeFilter = filterName => ({
  type: 'REMOVE_FILTER',
  filterName,
});

export const clearFilters = () => ({
  type: 'CLEAR_FILTERS',
});

export const clearSecondaryFilters = () => ({
  type: 'CLEAR_SECONDARY_FILTERS',
});

export const showAllFilterItems = (event, filterName) => ({
  type: 'SHOW_ALL_FILTER_ITEMS',
  event,
  filterName,
});

export const addMediaItems = () => ({
  type: 'ADD_MEDIA_ITEMS',
});

export const assetLoadComplete = event => ({
  type: 'ASSET_LOAD_COMPLETE',
  event,
});
